import { AxiosResponse } from "axios";
import { Property, PropertyQuery, PropertyRequest } from "../models/Property";
import axios from "../utils/axios";
import { BasicQuerySearch, QueryResponse } from "./utilts";

export function fetchPropertiesQuery(token: string, query = {}) {
  return new Promise<AxiosResponse<PropertyQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/properties/`, {
        headers: { Authorization: "Token " + token },
        params: query
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchQueryProperties(body: BasicQuerySearch & {
  top_category?: string;
  category?: string;
  sub_category?: string;
  a11y_standard?: string;
  type?: string;
} = {}, token: string) {
  return new Promise<QueryResponse<Property>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/properties/`,
        {
          headers: { 'Authorization': 'Token ' + token },
          params: body
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

type filterByTypes = {
  progress?: string, // show_all, completed, incomplete
  a11yStandard?: string,
  category?: string
  company?: string;
}

export function fetchPagedProperties(
  token: string,
  page: number,
  search: string,
  filterBy: filterByTypes,
  removeFirst: boolean = true
) {
  let params: any = {}

  if (filterBy.progress === 'completed') {
    params.accessibility_progress_bar_completion_percent = '1.0'
  } else if (filterBy.progress === 'incomplete') {
    params.accessibility_progress_bar_completion_percent_range_min='0.0'
    params.accessibility_progress_bar_completion_percent_range_max='0.9'
  }
  if (filterBy.a11yStandard) {
    params.a11y_standard = filterBy.a11yStandard
  }
  if (filterBy.category) {
    params.category = filterBy.category
  }
  if (filterBy.company) {
    params.company = filterBy.company
  }

  let el_limit = 8
  let offset = (page - 1) * 8;
  if (removeFirst && page === 1) {
    el_limit = 7
  }
  if (page === 2) {
    offset -= 1;
  }
  return new Promise<AxiosResponse<PropertyQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/properties/?limit=${el_limit}&offset=${offset}&search=${search.replace(/&/g, '%26')}`, {
        headers: { Authorization: "Token " + token },
        params: params,
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchPagedPropertiesWithLimit(
  token: string,
  page: number,
  limit: number,
  search?: string
) {
  let offset = (page - 1) * limit;
  let url = `${process.env.REACT_APP_API_DOMAIN}/properties/?limit=${limit}&offset=${offset}`
  if (search) {
    url += `&search=${search.replace(/&/g, '%26')}`
  }
  return new Promise<AxiosResponse<PropertyQuery>>((resolve, reject) => {
    axios
      .get(url, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchProperty(id: string, token: string) {
  return new Promise<AxiosResponse<Property>>((resolve, reject) => {
    axios
      .get<Property>(`${process.env.REACT_APP_API_DOMAIN}/properties/${id}/`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createProperty(data: PropertyRequest, token: string) {
  return new Promise<AxiosResponse<Property>>((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/properties/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 201) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updateProperty(data: PropertyRequest, token: string, id: string) {
  return new Promise<AxiosResponse<Property>>((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/properties/${id}/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function partialUpdateProperty(data: Partial<PropertyRequest>, token: string, id: string) {
  return new Promise<AxiosResponse<Property>>((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/properties/${id}/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function getAccessibilityUnitTypes(id: string, token: string) {
  return new Promise<AxiosResponse<Property>>((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/properties/${id}/`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
